class Klarna {
    constructor() {
        if (
            typeof Settings.services['klarna'] !== 'undefined' &&
            Settings.services['klarna']['enabled'] === true
        ) {
            this.klarna = window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
            this.isEnabled = true;
        } else {
            this.klarna = [];
            this.isEnabled = false;
        }
    }

    refreshPlacements() {
        return new Promise(async (resolve, reject) => {
            try {
                await this.klarna.push({ eventName: 'refresh-placements' });

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }

    loaded() {
        try {
            return this.klarna.loaded;
        } catch (error) {
            console.log(error);
        }
    }
}

export default new Klarna();
